import { useMemo } from 'react';

// Constants
import { MEDIUM_LONG_STAY, SHORT_STAY } from '../constants';

const useBookingUrl = ({
  activity, shortStayExternalUrl, contentIdResidence, shortStayMEWSConfigID,
}) => {
  const bookingUrl = useMemo(() => {
    const bookingPath = `/booking/formula?residence=${contentIdResidence}`;

    switch (activity) {
      case MEDIUM_LONG_STAY: {
        if (contentIdResidence) {
          return bookingPath;
        }
        return '';
      }
      case SHORT_STAY:
        return shortStayMEWSConfigID ? bookingPath : shortStayExternalUrl;
      default:
        return '';
    }
  }, [activity, shortStayExternalUrl, contentIdResidence]);

  return {
    bookingUrl,
  };
};

export default useBookingUrl;
